import { render, staticRenderFns } from "./SortingSessionReport.vue?vue&type=template&id=0a224736&scoped=true&"
import script from "./SortingSessionReport.vue?vue&type=script&lang=js&"
export * from "./SortingSessionReport.vue?vue&type=script&lang=js&"
import style0 from "./SortingSessionReport.vue?vue&type=style&index=0&id=0a224736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a224736",
  null
  
)

export default component.exports